'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res4, _Component);

  function Module2Res4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res4.__proto__ || (0, _getPrototypeOf2.default)(Module2Res4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Dealing with change'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module2Res4, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, lg: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Change can be difficult, but there are ways to help make it easier.'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.greenText },
              'The more you follow a new rule, the easier it becomes'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is important not to give up, even when it does not seem to be working. It may take time for children to learn that you are going to stick to that rule, no matter how much they dislike it'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Be prepared. If you know that children might not follow a new rule, it is important to decide what the consequences will be when the rule is broken. Whatever the consequences (eg. time out), it is very important that you stick to it'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is also easier to make a new rule when you know as much about it as possible. If you need more information, we suggest that you look through the modules or you might like to talk to your friends, family, your parents and other parents to see if they have faced a similar challenge'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is important to feel supported when making changes, so do not be afraid to seek support from people that you know and trust'
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res4.js
// module id = 1241
// module chunks = 0